import styled from 'styled-components';
import Button from '../../Controls/Button';
export const TheadButton = styled(Button) `
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
  border: 2px solid ${({ theme }) => theme.colors.grey00_1};
  &:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }
  &:not([disabled]) {
    ${({ theme }) => theme.shadows.shadowTuna}
  }
  svg {
    transition: 0.16s;
    transform: ${({ active }) => active && 'rotateX(180deg)'};
  }
`;
